<template>
  <Fragment>
    <tr class="no-hover">
      <td rowspan="2" colspan="1" :class="`px-1 pl-3 ${borderClass}`">
        <v-checkbox v-model="produto.$$active"
                    dense
                    color="primary"/>
      </td>
      <td rowspan="2" colspan="3" :class="`px-1 pr-3 ${borderClass}`">
        <px-span-tooltip v-if="checkCodigo(produto.cotacaoProduto.produto)"
                         top
                         :text="labelCodigo(produto.cotacaoProduto.produto)"
                         tooltip="Código interno" />
        <px-span-tooltip top
                         :text="labelDescricao(produto)"
                         :tooltip="produto.cotacaoProduto.produto.descricao" />
      </td>
      <td class="px-1 no-border-fixed-height" colspan="2">
        <px-input-currency dense
                           label="Preço unitário"
                           class="rounded-tag-small"
                           :disabled="!produto.$$active"
                           :options="configuracaoMoeda"
                           :precision="produto.cotacaoProduto.produto.casasDecimais"
                           :error="$v.produto.$$precoUnitario.$error"
                           @blur="$v.produto.$$precoUnitario.$touch()"
                           v-model="produto.$$precoUnitario"/>
      </td>
      <td class="px-1 no-border-fixed-height" colspan="1">
        <px-anexo :max="3"
                  :disabled="!produto.$$active"
                  @loading="onFileLoad"
                  v-model="produto.$$arquivosProduto"/>
      </td>
    </tr>
    <tr class="no-hover">
      <td class="px-1" colspan="3">
        <v-textarea label="Especificação fornecedor"
                    class="mb-2 mr-1 rounded-tag-small"
                    rows="1"
                    dense
                    outlined
                    hide-details
                    auto-grow
                    :disabled="!produto.$$active"
                    v-model="produto.$$especificacaoProduto" />
      </td>
    </tr>
  </Fragment>
</template>
<script>
import Vue from 'vue';
import { Fragment } from 'vue-frag';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import moedaMixin from '@/mixins/moeda-mixin';

export default {
  mixins: [validationMixin, moedaMixin],
  props: {
    produto: {
      type: Object,
      required: true,
    },
    moeda: String,
    showDivider: Boolean,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    checkCodigo() {
      return item => item.codigo;
    },
    labelCodigo() {
      return item => `${item.codigo} -`;
    },
    labelDescricao() {
      return produto => Vue.filter('truncate')(produto.cotacaoProduto.produto.descricao, 60);
    },
    borderClass() {
      return this.showDivider ? '' : 'no-border';
    },
  },
  methods: {
    onFileLoad(loading) {
      this.produto.$$hasFileLoading = loading;
    },
  },
  validations: {
    produto: {
      $$precoUnitario: {
        required,
        minValue(value, model) {
          if (!model.$$active) {
            return true;
          }
          return value > 0;
        },
      },
    },
  },
  components: {
    Fragment,
  },
};
</script>
<style scoped>
.no-border {
  border-bottom: none !important;
}

.no-border-fixed-height {
  border-bottom: none !important;
  height: 60px;
}
</style>
